"use strict";
// Global Variables
const omeka_baseURL = new URL("https://coronarchiv.geschichte.uni-hamburg.de");
const api_baseURL = new URL("https://coronarchiv.geschichte.uni-hamburg.de/projector/api?");
const api_itemURL = new URL("https://coronarchiv.geschichte.uni-hamburg.de/projector/api/items?");
const api_itemURLClean = new URL("https://coronarchiv.geschichte.uni-hamburg.de/projector/api/items");
const api_infoURLClean = new URL("https://coronarchiv.geschichte.uni-hamburg.de/projector/api/infos");
const allowedTypes = [
  "aac",
  "aif",
  "aiff",
  "asf",
  "asx",
  "avi",
  "bmp",
  "c",
  "cc",
  "class",
  "css",
  "divx",
  "doc",
  "docx",
  "exe",
  "gif",
  "gz",
  "gzip",
  "h",
  "ico",
  "j2k",
  "jp2",
  "jpe",
  "jpeg",
  "jpg",
  "m4a",
  "m4v",
  "mdb",
  "mid",
  "midi",
  "mov",
  "mp2",
  "mp3",
  "mp4",
  "mpa",
  "mpe",
  "mpeg",
  "mpg",
  "mpp",
  "odb",
  "odc",
  "odf",
  "odg",
  "odp",
  "ods",
  "odt",
  "ogg",
  "opus",
  "pdf",
  "png",
  "pot",
  "pps",
  "ppt",
  "pptx",
  "qt",
  "ra",
  "ram",
  "rtf",
  "rtx",
  "swf",
  "tar",
  "tif",
  "tiff",
  "txt",
  "wav",
  "wax",
  "webm",
  "wma",
  "wmv",
  "wmx",
  "wri",
  "xla",
  "xls",
  "xlsx",
  "xlt",
  "xlw",
  "zip",
];
